// src/store/modules/auth.js
const state = {
    token: localStorage.getItem('token') || '',
    userSelf: null,
};

const mutations = {
    setToken(state, token) {
        state.token = token;
    },
    clearToken(state) {
        state.token = '';
    },
    setUserSelf(state, user) {
        state.userSelf = user;
    },
    clearUserSelf(state) {
        state.userSelf = null;
    },
};

const actions = {
    signin({ commit }, token) {
        commit('setToken', token);
        localStorage.setItem('token', token);
    },
    signout({ commit }) {
        commit('clearToken');
        localStorage.removeItem('token');
    },
    updateUserSelf({ commit }, user) {
        commit('setUserSelf', user);
    },
    clearUserSelf({ commit }) {
        commit('clearUserSelf');
    },
};

const getters = {
    isAuthenticated: state => !!state.token,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
